<template>
  <div>
    <button type="submit" class="dropdown-link" v-if="as == 'button'">
      <slot></slot>
    </button>

    <subdomain-link :root="root" :href="href" class="dropdown-link" v-else>
      <slot></slot>
    </subdomain-link>
  </div>
</template>

<script>
  export default {
    props: {
      href: String,
      as: { type: String, default: 'link' },
      root: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
